import { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import Search from './Search';
// import Message from './Message';
import { Box } from '@mui/system';
import Badge from '@mui/material/Badge';
import IconButton from '../../../../components/@extended/IconButton';
import Notification from './Notification';
import { AiOutlineSetting } from "react-icons/ai";
import { MdMailOutline } from "react-icons/md";
import useConfig from '../../../../hooks/useConfig';
import { MenuOrientation } from '../../../../config';
import DrawerHeader from '../../../../layout/Dashboard/Drawer/DrawerHeader';
import { useNavigate } from 'react-router';
import { useUserContext } from '../../../../contexts/UserContext';
import ContactModal from '../../../../components/ContactModal';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const { selectedVenueData } = useUserContext();
  const { menuOrientation } = useConfig();
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const navigate = useNavigate();
  const [contactModal, setContactModal] = useState({ open: false });

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}

      <Search />

      {selectedVenueData && (
        <Notification />
      )}

      {/* <Message /> */}

      <Box sx={{ flexShrink: 0 }}>
        <IconButton
          color="secondary"
          variant="light"
          sx={(theme) => ({
            color: 'text.primary',
            bgcolor: 'transparent',
            '&:hover': {
              bgcolor: 'transparent',
              color: 'text.primary',
            },
            ...theme.applyStyles('dark', { bgcolor: open ? 'background.default' : 'transparent' })
          })}
          onClick={() => navigate('/dashboard/settings')}
        >
          <Badge>
            <AiOutlineSetting style={{ fill: 'black' }} />
          </Badge>
        </IconButton>
      </Box>
      
      <Box sx={{ flexShrink: 0 }}>
        <IconButton
          color="secondary"
          variant="light"
          sx={(theme) => ({
            color: 'text.primary',
            bgcolor: 'transparent',
            '&:hover': {
              bgcolor: 'transparent',
              color: 'text.primary',
            },
            ...theme.applyStyles('dark', { bgcolor: open ? 'background.default' : 'transparent' })
          })}
          onClick={() => setContactModal({open: true})}
        >
          <Badge>
            <MdMailOutline style={{ fill: 'black' }} />
          </Badge>
        </IconButton>
      </Box>

      <ContactModal setContactModal={setContactModal} contactModal={contactModal} />
    </>
  );
}
